import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import { useState, useRef, useEffect } from "react";

export function DarkSidebar({ title, icon, children, className = "" }) {
    const [expanded, setExpanded] = useState(false);
    const buttonRef = useRef(null);
    const sidebarRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                sidebarRef.current?.contains(event.target) ||
                buttonRef.current?.contains(event.target)
            ) {
                return;
            }
            setExpanded(false);
        }

        if (expanded) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [expanded]);

    return (
        <>
            <a
                onClick={() => setExpanded(!expanded)}
                ref={buttonRef}
                className={`topbar-button ${expanded ? "active" : ""}`}
                role="button"
            >
                <FontAwesomeIcon icon={icon} className="topbar-icon" /> {title}
                <FontAwesomeIcon
                    icon={faChevronDown}
                    className="topbar-icon chevron ms-1"
                />
            </a>

            {expanded && (
                <div
                    ref={sidebarRef}
                    className={`dark-sidebar ${className} text-start expanded p-4 `}
                >
                    {children}
                </div>
            )}
        </>
    );
}
